// extracted by mini-css-extract-plugin
export default {"table_header":"PppLinksTable_table_header__NMvM4"};